import 'react-datepicker/dist/react-datepicker.css';
import * as Yup from 'yup';
import { DatePickerField } from '../../../components/common/admin/DatePickerField';
import { ErrorMessage, Formik } from 'formik';
import { Form } from 'react-bootstrap';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { ZDAR_ESCAPE_GAME_NAME, ZDAR_KIDS_GAME_NAME } from '../../../configuration/gamesConfiguration';
import { toast } from 'react-toastify';
import { useAddGameMutation } from '../../../gql-types';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../../components/common/buttons/Button';

export default function AddGame() {
    const history = useHistory();
    const { token } = useContext(ProfileContext);
    const [addGame] = useAddGameMutation();

    const goBack = () => {
        history.push('/admin');
    };

    const schema = Yup.object({
        firstName: Yup.string().required(),
        lastName: Yup.string().required(),
        email: Yup.string().email().required(),
        code: Yup.string()
            .required()
            .matches(/^[0-9a-zA-Z]+$/, 'Kód může obsahovat pouze písmena a číslice')
            .length(10, 'Kód musí mít přesně 10 znaků'),
        gameType: Yup.string().required('Vyberte typ hry'),
        validFrom: Yup.date().required(),
        validTo: Yup.date().required(),
    });

    return (
        <div className="admin-add-mode-wrapper">
            <Button className="primary-button" onClick={goBack}>
                Zpět
            </Button>
            <Formik
                validationSchema={schema}
                onSubmit={(values) => {
                    const from = values.validFrom;
                    const to = values.validTo;
                    from.setHours(0);
                    from.setMinutes(0);
                    from.setSeconds(0);
                    from.setMilliseconds(0);
                    to.setHours(23);
                    to.setMinutes(59);
                    to.setSeconds(59);
                    to.setMilliseconds(999);
                    const gameObject = {
                        variables: {
                            ...values,
                            validFrom: Math.floor(from.getTime() / 1000).toString(),
                            validTo: Math.floor(to.getTime() / 1000).toString(),
                            jwt: token,
                        },
                    };
                    // @ts-expect-error
                    addGame(gameObject)
                        .then(() => {
                            toast('Hra přidána', { type: 'success' });
                            goBack();
                        })
                        .catch((err) => {
                            console.log(err);
                            toast('Chyba - hra neuložena.', { type: 'error' });
                        });
                }}
                initialValues={{
                    firstName: '',
                    lastName: '',
                    email: '',
                    code: '',
                    gameType: '',
                    validFrom: new Date(),
                    validTo: new Date(),
                }}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
            >
                {({ handleSubmit, handleChange, handleBlur, values, touched, errors, setFieldValue }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Row>
                            <Form.Group controlId="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isValid={touched.email && !errors.email}
                                />
                                <ErrorMessage
                                    render={(msg) => <div className="form-error">{msg}</div>}
                                    name={'email'}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group controlId="firstName">
                                <Form.Label>Jméno</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="firstName"
                                    value={values.firstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isValid={touched.firstName && !errors.firstName}
                                />
                                <ErrorMessage
                                    render={(msg) => <div className="form-error">{msg}</div>}
                                    name={'firstName'}
                                />
                            </Form.Group>
                            <Form.Group controlId="lastName">
                                <Form.Label>Příjmení</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="lastName"
                                    value={values.lastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isValid={touched.lastName && !errors.lastName}
                                />
                                <ErrorMessage
                                    render={(msg) => <div className="form-error">{msg}</div>}
                                    name={'lastName'}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group controlId="code">
                                <Form.Label>Kód</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="code"
                                    value={values.code}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isValid={touched.code && !errors.code}
                                    maxLength={10}
                                />
                                <ErrorMessage render={(msg) => <div className="form-error">{msg}</div>} name={'code'} />
                            </Form.Group>
                            <Form.Group controlId="gameType">
                                <Form.Label>Typ hry</Form.Label>
                                <Form.Control
                                    as="select"
                                    type="select"
                                    name="gameType"
                                    value={values.gameType}
                                    onChange={handleChange}
                                    isValid={touched.gameType && !errors.gameType}
                                >
                                    <option>-</option>
                                    <option value={ZDAR_ESCAPE_GAME_NAME}>Žďárska únikovka</option>
                                    <option value={ZDAR_KIDS_GAME_NAME}>Dětská únikovka</option>
                                </Form.Control>
                                <ErrorMessage
                                    render={(msg) => <div className="form-error">{msg}</div>}
                                    name={'gameType'}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group controlId="validFrom">
                                <Form.Label>Platnost od</Form.Label>
                                <div className="datepicker-wrapper">
                                    <DatePickerField
                                        name="validFrom"
                                        value={values.validFrom.toLocaleDateString('cs-CZ')}
                                        onChange={handleChange}
                                        isValid={touched.validFrom && !errors.validFrom}
                                    />
                                </div>
                                <ErrorMessage
                                    render={(msg) => <div className="form-error">{msg}</div>}
                                    name={'validFrom'}
                                />
                            </Form.Group>
                            <Form.Group controlId="validTo">
                                <Form.Label>Platnost do</Form.Label>
                                <div className="datepicker-wrapper">
                                    <DatePickerField
                                        name="validTo"
                                        value={values.validTo.toLocaleDateString('cs-CZ')}
                                        onChange={handleChange}
                                        isValid={touched.validTo && !errors.validTo}
                                    />
                                </div>
                                <ErrorMessage
                                    render={(msg) => <div className="form-error">{msg}</div>}
                                    name={'validTo'}
                                />
                            </Form.Group>
                            <Form.Group controlId="validToButton">
                                <Button
                                    className="info-button"
                                    onClick={() => {
                                        const newDate = new Date(values.validFrom);
                                        newDate.setMonth(values.validFrom.getMonth() + 6);
                                        setFieldValue('validTo', newDate);
                                    }}
                                >
                                    {`Nastavit "Platnost do" za 6 měsíců`}
                                </Button>
                            </Form.Group>
                        </Form.Row>
                        <Button className="secondary-button secondary-button__margin" onClick={handleSubmit}>
                            Vytvořit
                        </Button>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
